import state from "./module-refund-state";
import mutations from "./module-refund-mutations";
import actions from "./module-refund-actions";
import getters from "./module-refund-getters";

export default {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
